import $ from 'jquery';
import { protectRoute, commonMiddleware } from '../middleware';
import { router } from '~src/router';
import { openTemplateManagerById } from '~loader';
import { showSpinner, hideSpinner } from '~loader/loader-utils';
import { modifyState } from '~src/state';
import { isLoggedUserGlobalEditor } from '~src/user';
import {
  EDITOR_MODE_GLOBAL_TEMPLATE_MANAGER,
  EDITOR_MODE_ORG_TEMPLATE_MANAGER,
} from '~config/editorConstants';

export const templateManagerRoute = async ({ data }) => {
  await protectRoute();
  await commonMiddleware();

  $('#route-canvas').show();
  showSpinner();

  if (!data || !data.id) {
    return router.navigate(process.env.ROUTE_START || '/');
  }
  const isGlobalEditor = await isLoggedUserGlobalEditor();
  modifyState(
    'editorMode',
    isGlobalEditor
      ? EDITOR_MODE_GLOBAL_TEMPLATE_MANAGER
      : EDITOR_MODE_ORG_TEMPLATE_MANAGER
  );
  await openTemplateManagerById(data.id);
  hideSpinner();
};
